module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\r\n    <div id="primary-physician-name-select" class="col-xs-5 col-md-5"></div>\r\n    <div class="col-xs-2 col-md-2">\r\n        <input class="form-control primary-physician-date-of-last-visit" type="text" placeholder="Date of last visit">\r\n    </div>\r\n    <div class="col-md-2 col-xs-2">\r\n        ';
 if (showRemove) { 
__p+='\r\n        <div class="checkbox">\r\n            <span class="remove-physician dotted-link edit-buttons right-buttons" style="color: red;">- Remove</span>\r\n        </div>\r\n        ';
 } 
__p+='\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/med-forms/physician-form.html
// module id = 516
// module chunks = 0